var site = site || {};

(function ($) {
  Drupal.behaviors.skuSelectV1 = {
    attach: function (context, settings) {
      var self = this;
      var $addToBag = $('.product-full .btn-add-to-bag', context);
      var $addToFavorites = $('.product-full .btn-add-to-favorites', context);
      var $skuSelect = $('.sku_select', context);
      var $shadePicker = $('.product-shade-picker__shades', context);
      var $shadePickersAll = $('.product-shade-picker__shades, .product-shade-picker__show-all-shades-panel', context);
      var $shades = $('.product-shade-picker__shade-inner, .product-shade-picker__show-all-shades__inner', context);
      var $showAllShadesBtn = $('.product-shade-picker__show-all-shades', context);
      var $showAllShadesPanel = $('.product-shade-picker__show-all-shades-panel', context);
      var productData = page_data['catalog-spp']['products'][0];
      var skus = productData.skus;

      $skuSelect.on('change', function () {
        var sku = $(this).val();

        $shadePickersAll.find('.product-shade-picker__shade-inner, .product-shade-picker__show-all-shades__inner').removeClass('active');
        $shadePickersAll.find('[data-skubaseid="' + sku + '"]').addClass('active');
        var skuData = self.getSku(parseInt(sku));

        self.skuSelect($addToBag, $addToFavorites, skuData, context);
      });

      $shades.once().on('click', function () {
        var $selectedShade = $(this);

        $shades.removeClass('active');

        $('.product-shade-picker__shade-inner[data-skubaseid=\'' + $selectedShade.data('skubaseid') + '\']').addClass('active');
        $('.product-shade-picker__show-all-shades__inner[data-skubaseid=\'' + $selectedShade.data('skubaseid') + '\']').addClass('active');
        $skuSelect.each(function () {
          $(this).val($selectedShade.data('skubaseid')).prop('selected', true);
        });
        var skuData = self.getSku(parseInt($selectedShade.data('skubaseid')));

        self.skuSelect($addToBag, $addToFavorites, skuData, context);
      });

      $showAllShadesBtn.once().on('click', function () {
        var $thisButton = $(this);

        $thisButton.toggleClass('open');
        $showAllShadesPanel.toggleClass('open');
        $shadePicker.toggleClass('hidden');
        $thisButton.html($thisButton.hasClass('open') ? site.translations.product.fewer_shades_text : site.translations.product.all_shades_text);
      });

      // init Default Sku if it's sold out find the first sku that's not sold out.
      var defaultSku = productData.defaultSku;
      var updatedSku = false;

      if (skus.length > 1) {
        if (!site.productData.isSkuDisplayable(productData.defaultSku)) {
          for (var sku in skus) {
            if (site.productData.isSkuDisplayable(skus[sku])) {
              updatedSku = true;
              defaultSku = skus[sku];
              self.skuSelect($addToBag, $addToFavorites, defaultSku, context);
              break;
            }
          }
        }
      }
      if (!updatedSku && !!defaultSku) {
        self.skuSelect($addToBag, $addToFavorites, defaultSku, context);
      }
    },
    skuSelect: function (addToBagBtn, addToFavoritesBtn, skuData, context) {
      var $productFull = $('.product-full', context);
      var $mainImg = $('.product-full__image--main-product', context);
      var $mainSmoosh = $('.product-full__image--main-smoosh', context);
      var $multiSmooshes = $('.product-full__image--multi-smoosh', context);
      var $productStatusContainer = $('.spp_product_status', context);
      var $productAutoReplenish = $('.product-full__autoreplenish', context);
      var $productPropertyList = $('.product-property-list', context);
      var $productProperties = $('.product-property', context);
      var $productFinish = $('.product-finish', context);
      var $productFinishName = $('.product-finish__name', context);
      var $productColorGroup = $('.product-color-group', context);
      var $productColorGroupName = $('.product-color-group__name', context);
      var $productCoverage = $('.product-coverage', context);
      var $productCoverageName = $('.product-coverage__name', context);
      var $productUndertone = $('.product-undertone', context);
      var $productUndertoneName = $('.product-undertone__name', context);
      var $addToBagWrapper = $('.add-to-bag__container', context);
      var $tempOutOfStock = $('.temp_out_of_stock_msg', context);
      var $comingSoonMesage = $('.coming_soon_stock_msg', context);
      var product = page_data['catalog-spp']['products'][0];
      var $productWrapper = $('.js-spp-content');
      var showCartridgeTaxedPrice = Drupal.settings.globals_variables.show_cartridge_taxed_price;

      if (!!skuData) {
        $productWrapper.trigger('skuSelect:ingredients', skuData);
      }

      if (skuData.IMAGE_ZOOM) {
        $mainImg.attr('src', skuData.IMAGE_ZOOM);
        $('.product-full__alt-images-thumb.js-main-img img').attr('src', skuData.IMAGE_ZOOM);
      }
      if (skuData.HEX_VALUE_STRING) {
        $('.product-swatch-selector .sbHolder').css('background-color', skuData.HEX_VALUE_STRING_ARRAY[0]);
        $('.js-swatch-selector .sbSelector').html(skuData.SHADENAME);

        if (product.isMultiSmoosh) {
          for (var hexIndex in skuData.HEX_VALUE_STRING_ARRAY) {
            $($('.thumb-multi-smoosh')[hexIndex]).css('background-color', skuData.HEX_VALUE_STRING_ARRAY[hexIndex]);
            $($multiSmooshes[hexIndex]).css('background-color', skuData.HEX_VALUE_STRING_ARRAY[hexIndex]);
            // this is a minor hack to get the doubled insances of the slider
            $($multiSmooshes[parseInt(hexIndex) + skuData.HEX_VALUE_STRING_ARRAY.length]).css('background-color', skuData.HEX_VALUE_STRING_ARRAY[hexIndex]);
          }
        } else {
          $('.product-full__alt-images-thumb.js-smoosh img').css('background-color', skuData.HEX_VALUE_STRING);
          $mainSmoosh.css('background-color', skuData.HEX_VALUE_STRING);
        }
      } else { // is sized
        $('.js-size-selector .sbSelector').html(skuData.PRODUCT_SIZE);
      }

      if (skuData.REFILLABLE) {
        $productAutoReplenish.removeClass('hidden');
      } else {
        $productAutoReplenish.addClass('hidden');
      }

      if (skuData.FINISH) {
        $productFinishName.html(skuData.FINISH);
        $productFinish.removeClass('hidden');
      } else {
        $productFinish.addClass('hidden');
      }

      if (skuData.ATTRIBUTE_COLOR_FAMILY) {
        $productColorGroupName.html(skuData.ATTRIBUTE_COLOR_FAMILY);
        $productColorGroup.removeClass('hidden');
      } else {
        $productFinish.addClass('hidden');
      }

      if (skuData.UNDERTONE) {
        $productUndertoneName.html(skuData.UNDERTONE);
        $productUndertone.removeClass('hidden');
      } else {
        $productUndertone.addClass('hidden');
      }

      $productPropertyList.addClass('hidden');

      $productProperties.each(function () {
        var property = $(this);

        if (!property.hasClass('hidden')) {
          $productPropertyList.removeClass('hidden');

          return;
        }
      });

      addToBagBtn.data('skubaseid', skuData.SKU_BASE_ID);
      addToFavoritesBtn.data('skubaseid', skuData.SKU_BASE_ID);

      $('.js-sticky-add-to-bag__image', context).attr('src', skuData.IMAGE_ZOOM);

      var priceBlock = '';
      var $priceBlockContainer = $('.js-product-full__price', context);

      if (skuData.PRICE2) {
        priceBlock = '<span class="formatted_price2 strike-thru-price" data-product-price="' + skuData.PRICE2 + '">' + skuData.formattedPrice2 + '</span> <span class="formatted_price sale-price">' + skuData.formattedPrice + '</span>';
      } else if (showCartridgeTaxedPrice && skuData.formattedCartridgeTaxedPrice) {
        priceBlock = '<div class="price"><span class="formatted_price">' + skuData.formattedCartridgeTaxedPrice + '</span></div>';
      } else {
        skuData.formattedPrice = Drupal.settings.show_cartridge_price ? skuData.formattedCartridgePrice : $priceBlockContainer.data('formattedPrice') || skuData.formattedPrice;
        priceBlock = '<div class="price">' + site.translations.product.currency_type + '<span class="formatted_price">' + skuData.formattedPrice + '</span></div>';
      }
      $('.product-full__price', context).html(priceBlock);

      // 2019 Redesign - check if function is real before loading it
      if (typeof site.quickshop.initAddToBag !== 'undefined') {
        site.quickshop.initAddToBag(addToBagBtn, skuData.SKU_BASE_ID, skuData);
      }
      if (typeof site.quickshop.initAddToFavorites !== 'undefined') {
        site.quickshop.initAddToFavorites(addToFavoritesBtn, $productFull, skuData.SKU_BASE_ID);
      }

      $productStatusContainer.children().addClass('hidden');
      $addToBagWrapper.addClass('hidden');
      $comingSoonMesage.addClass('hidden');
      $tempOutOfStock.addClass('hidden');
      addToBagBtn.removeClass('pre-order-btn');

      switch (skuData.INVENTORY_STATUS) {
        case 1:
          $addToBagWrapper.removeClass('hidden');
          break;
        case 2:
          $addToBagWrapper.removeClass('hidden');
          $tempOutOfStock.removeClass('hidden');
          break;
        case 3:
          $comingSoonMesage.removeClass('hidden');
          break;
      }

      if (skuData.isPreOrder) {
        addToBagBtn.addClass('pre-order-btn').html(site.translations.product.preorder);
      } else {
        addToBagBtn.removeClass('pre-order-btn').html(site.translations.product.add_to_bag);
      }

      site.quickshop.setBuyButtonStatus(skuData, $productFull);
    },
    getSku: function (skuID, context) {
      var skus = page_data['catalog-spp']['products'][0].skus;

      for (var i in skus) {
        if (skuID === skus[i].SKU_BASE_ID) {
          return skus[i];
        }
      }
    }
  };
})(jQuery);
